// packages/shared/src/components/ui/Button.jsx

export function Button({ 
    variant = 'primary', 
    size = 'md', 
    loading = false,
    fullWidth = false,
    className = '',
    children,
    disabled,
    ...props 
  }) {
    // Base classes from provider app button
    const baseClasses = 'font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
    
    const variants = {
      primary: 'bg-primary text-white hover:opacity-90 focus:ring-primary',
      secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus:ring-gray-500',
      danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600',
      ghost: 'text-gray-700 hover:bg-gray-100 focus:ring-gray-500'
    };
    
    const sizes = {
      sm: 'py-2 px-3 text-sm rounded-md',
      md: 'py-3 px-4 rounded-lg',  // Matching provider app button
      lg: 'py-4 px-6 text-lg rounded-lg'
    };
    
    const widthClass = fullWidth ? 'w-full' : '';
    
    return (
      <button
        className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? (
          <div className="flex items-center justify-center">
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
            {children}
          </div>
        ) : (
          children
        )}
      </button>
    );
  }